/*
  meet-ozempic-video — reveal sequence + lazy video loading for
  sections/meet-ozempic-video.liquid.

  Reveal runs once per page visit (see spec: repeating every loop is noisy).
  Honours prefers-reduced-motion by showing everything immediately.
*/
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function revealAll(root) {
    root.querySelectorAll('[data-mov-reveal]').forEach(function (el) {
      el.style.transitionDelay = '0s';
      el.classList.add('is-revealed');
    });
    root.classList.add('is-revealed-done');
  }

  function runReveal(root) {
    if (root.classList.contains('is-revealed-done')) return;
    root.classList.add('is-revealed-done');

    if (REDUCED.matches) {
      revealAll(root);
      return;
    }

    root.querySelectorAll('[data-mov-reveal]').forEach(function (el) {
      var delay = parseInt(el.getAttribute('data-mov-reveal'), 10) || 0;
      window.setTimeout(function () {
        el.classList.add('is-revealed');
      }, delay);
    });
  }

  /* Swap data-src -> src only when the section is near the viewport so the
     video isn't fetched on pages the visitor never scrolls to. */
  function loadVideo(video) {
    if (!video || video.dataset.movLoaded) return;
    video.dataset.movLoaded = '1';
    video.querySelectorAll('source[data-src]').forEach(function (source) {
      source.src = source.getAttribute('data-src');
      source.removeAttribute('data-src');
    });
    video.load();
    var attempt = video.play();
    /* Safari rejects autoplay in low-power mode — surface the poster instead
       of an empty frame and let the play control take over. */
    if (attempt && attempt.catch) {
      attempt.catch(function () {
        video.closest('[data-mov-root]')?.classList.add('is-video-paused');
      });
    }
  }

  function initPlayToggle(root, video) {
    var btn = root.querySelector('[data-mov-toggle]');
    if (!btn || !video) return;

    btn.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        root.classList.remove('is-video-paused');
        btn.setAttribute('aria-label', btn.dataset.labelPause);
      } else {
        video.pause();
        root.classList.add('is-video-paused');
        btn.setAttribute('aria-label', btn.dataset.labelPlay);
      }
    });
  }

  function init(root) {
    if (root.dataset.movInit) return;
    root.dataset.movInit = '1';

    var video = root.querySelector('[data-mov-video]');
    initPlayToggle(root, video);

    if (!('IntersectionObserver' in window)) {
      loadVideo(video);
      revealAll(root);
      return;
    }

    /* Preload the video slightly before it scrolls in… */
    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        loadVideo(video);
        obs.disconnect();
      });
    }, { rootMargin: '400px 0px' }).observe(root);

    /* …but only start the reveal once it is genuinely in view. */
    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        runReveal(root);
        obs.disconnect();
      });
    }, { threshold: 0.25 }).observe(root);
  }

  function initAll() {
    document.querySelectorAll('[data-mov-root]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState !== 'loading') initAll();

  /* Theme editor re-renders the section on every setting change. */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-mov-root]').forEach(init);
  });
})();
